import useSWR from "swr"

export const useDataset = () => {
    const { data: Datasets } = useSWR(`/screener/getDatasetsOptions`)

    return {Datasets}
}

export default useDataset